
export const m = {

  // common
  submit: 'Submit',
  updatedSuccess: 'Updated successfully',
  saveSuccess: 'Save successfully',
  save: 'Save',
  cancel: 'Cancel',
  confirm: 'Confirm',
  close: 'Close',
  add: 'Add',
  clear: 'Clear',
  required: 'Required',
  logout: 'Logout',
  unit: 'Unit',
  comfirmQuit: 'Are you sure to quit?',
  noRecord: 'No record ~',
  aboutus: 'About us',
  contactus: 'Contact us',
  aboutPortdistance: 'About PortDistance',
  aboutMarineCircle: 'About MarineCircle',
  shopping: 'Price and Buy',
  purchaseInfo: 'Purchase information',

  // 登录 注册
  login: 'Login',
  email: 'E-mail',
  password: 'Password',
  forgetPassword: 'Forgotten Your Password?',
  createAccount: 'Create an account',
  signin: 'Sign In',
  errorLogin: 'Email address or password is incorrect！',
  signup: 'Sign Up',
  nickname: 'Nickname',
  company: 'Company',
  hasAccount: 'Already have an account? Login',
  passwordMinLength: 'Password must be more than 6 characters',
  emailInvalid: 'E-mail must be valid',
  nicknameInvalid: 'Nickname must be valid',
  companyInvalid: 'Company must be valid',
  nicknameHint: '4 to 16(letters, numbers, underlines)',
  companyHint: 'At least 4 characters',
  emailBeUsed: 'This email has been registered',
  nicknameBeUsed: 'This Nickname has been registered',

  signupSuccess: 'Register successfully, please log in',
  enterRegisteredEmail: 'Please enter your registered email',
  notExistedEmail: "This email hasn't been registered.",
  checkMailBox: 'Please check your mail box.',
  resetLinkSent: 'Password reset link has been sent.',

  // 设置 与 左菜单
  distance: 'Distance',
  estimation: 'Estimation',
  vessel: 'Vessel',
  setting: 'Settings',

  personalProfile: 'Personal Profile',
  personalInfo: 'Personal Information',
  realName: 'Real Name',
  mobile: 'Mobile',
  gender: 'I am',
  pleaseChoose: 'Please Select',
  male: 'Male',
  female: 'Female',
  companyInformation: 'Company Information',
  title: 'Title',
  department: 'Department',
  nation: 'Nation',
  tel: 'Tel',
  city: 'City',
  address: 'Address',
  aboutMe: 'About Me',

  changePasswd: 'Change Password',
  oldPasswd: 'Current Password',
  newPasswd: 'New Password',
  crrntPsswrdIncrrct: 'Current password is incorrect',
  updatedPassword: 'Password updated',
  changeAccount: 'Change Account',
  changeAccount2: 'Change email account',
  accountEmailHint: 'Your account will take effect after confirmation. Check the link we sent to your new email address.',
  newEmailAddress: 'New Email Address',
  checkExistedEmail: 'This email address has already been registered!',

  language: 'Language',
  marinecircle: 'MarineCircle Info&Tech Co. Ltd.',

  // 航程计算 与 航次预算
  nm: 'NM',
  port: 'Port',
  distance: 'Distance',
  seaDays: 'Sea Time',
  idleDays: 'Idle Time',
  workDays: 'Work Time',
  seaDaysShort: 'Sea',
  idleDaysShort: 'Idle',
  workDaysShort: 'Work',
  days: 'Days',
  ttlDistance: 'TTL Distance',
  ttlEcaDistance: 'ECA Distance',
  ttlTime: 'TTL Time',
  getDistance: 'Get Distance',

  turningConfig: 'Modify Waypoint',
  turningPointsEdit: 'Coordinates',
  lonLatDecimal: 'Decimal',
  dms: 'DMS',
  dm: 'DM',
  lonAbbrev: 'LON',
  latAbbrev: 'LAT',
  addWayPoint: 'Add a waypoint',
  updateWayPoint: 'Modify',
  delWayPoint: 'Delete',
  enterValidLonLat: 'Enter a valid longitude and latitude.',
  enterCoordinate: 'Enter Coordinate',

  // 航程计算
  moreDisInfo: 'More results',
  clearOnlyDis: 'Clear Distance',
  clearDisAll: 'Clear All',
  enterPort: 'Enter Port (At least 2 keywords)',
  asl: 'ASL Compliance',
  antiPiracy: 'Anti-Piracy Routing',
  pointOptionExc: 'Not Allow to via the RP',
  pointOptionDefault: 'Allow to via the RP',
  pointOptionRequired: 'Via the Routing Point',

  routingPointStatus: 'Routing point options',
  plsGetDistance: 'Please complete the voyage calculation first',
  wayPointExists: 'This route point exists',
  thePortExists: 'This port exists',
  gettedDistanceFail: 'An error occurred in calculation. The waypoint does not exist',

  // 航次预算
  comfirmDelEsti: 'Do you want to delete this estimation?',

  editEsti: 'Edit Estimation',
  addEsti: 'Add Estimation',

  cargoInfo: 'Cargo Information',
  cargo: 'Cargo',
  portRotation: 'Port Sequence',
  particularAndFuel: 'Vessel Particular and Fuel',
  costAndResult: 'Cost and Result',
  cost: 'Cost',
  enterEstiName: 'Enter Estimation Name',
  estiName: 'Estimation Name',
  estiNameRequired: 'Estimation name is required',
  littleCargoInfo: 'Too little cargo information!',
  noGeneratePortList: 'Not generating port sequence!',
  inputCargoAndPort: 'Please input cargo type and L/D ports!',
  selectArrivedDate: 'Please select the date of arrival',
  datePicker: 'DatePicker',
  cargoType: 'Cargo type',
  cargoQuantity: 'Quantity',
  fee: 'Freight',
  income: 'Income',
  lPort: 'L Port',
  dPort: 'D Port',
  addCommRate: 'Add. Comm',
  brokerageRate: 'Brokerage',
  frtTaxRate: 'Freight Tax',
  ttlVoyDays: 'Voyage Time(Days)',
  ttlSeaDays: 'Sea',
  ttlPortIdleDays: 'Port Idle',
  ttlPortWorkDays: 'Port Work',
  openMap: 'Open map',
  clearPortSeq: 'Clear Seq',
  genPortSeq: 'Generate',
  taskTypeName: 'Task',
  portCharge: 'Port charge',
  arrivedDate: 'ETA',
  arrivedTime: 'ETA Time',
  departed: 'ETD',
  margin: 'Margin',
  addPort: 'Add port',
  addPortPosition: 'Position',
  portPosTop: 'Top',
  portPosBottom: 'Bottom',
  getDis: 'Get Distance',
  clearDis: 'Clear',
  addPortTo: 'Add to',
  clearSeqConfirm: 'Have you obtained the voyage, confirm clear port sequence?',
  clearDisConfirm: 'Confirm clear distance？',
  inputCargoAndLD: 'Please input cargo type and L/D ports',
  selectVessel: 'Select Vessel',
  vesselForEsti: 'Vessel',
  speedFull: 'Full',
  speedEco: 'Eco',
  speedBallast: 'Speed(Ballast)',
  speedLaden: 'Speed(Laden)',
  foConsump: 'FO(MT/Day)',
  doConsumpForEsti: 'DO(MT/Day)',
  consumption: 'Consumption',
  price: 'Price',
  cost: 'Cost',

  hirePerDay: 'Hire/Day',
  hire: 'Hire',
  hireCommPercent: 'Hire Comm.',
  demurrage: 'Demurrage',
  dispatch: 'Dispatch',
  ilohc: 'ILOHC',
  ballastBonus: 'BallastBonus',
  opOther: 'OpOther',
  cev: 'CEV',
  fuelCost: 'Fuel Cost',
  opCost: 'OP Cost',
  estiResult: 'Results',
  asHirePerDay: 'As Hire/Day',
  opProfit: 'OP Profit',
  ttlRevenue: 'TTL Revenue',
  netProfit: 'Net Profit',

  taskBallast: 'Ballast',
  taskLoading: 'Loading',
  taskDischarging: 'Discharging',
  taskBunker: 'Bunker',
  taskCanal: 'Canal',
  taskPassing: 'Passing',
  taskRouting: 'Routing',

  // 船舶规范
  deleteVessel: 'Do you want to delete this vessel?',
  completeBaseVessel: 'Please complete the basic specification completely!',
  ton: 'MT',
  meter: 'M',
  speed: 'Speed',
  knots: 'Knots',
  cbm: 'CMB',

  vesselParticulars: 'Vessel Particulars',
  editParticular: 'Edit Vessel Particular',
  addParticular: 'Add Vessel',
  vesselBase: 'Basic',
  shipName: 'Name',
  inputShipName: 'Please input vessel name',
  vesselExists: 'This ship name already exists',
  vesselType: 'Vessel Type',
  dwt: 'DWT',
  inputDwt: 'Please input DWT',
  dwtIsNumber: 'DWT should be a number',
  flag: 'Flag',
  chooseVesselFlag: 'Please choose vessel flag',
  builtYear: 'Built Year',
  inputBuiltYear: 'Please input built year',
  draft: 'Draft',
  inputDraft: 'Please input draft',
  draftIsNumber: 'Draft should be a number',
  dwcc: 'DWCC',
  grt: 'GRT',
  nrt: 'NRT',
  loa: 'LOA',
  inputLoa: 'Please input LOA',
  loaIsNumber: 'LOA should be a number',
  beam: 'BEAM',
  depth: 'DEPTH',
  particularText: 'Particular Text',
  inputParticular: 'Paste or edit your particular text here',
  holdHatch: 'Hold & Hatch',
  gbCapticity: 'Grain / Bale Capacity',
  holdHatchDeck: 'Hold / Hatch / Deck Number',
  hatchType: 'Hatch Type',
  hatchSize: 'Hatch Size',
  holdSize: 'Hold Size',
  gearDesc: 'Gear',
  otherDetail: 'Other Details',
  iMOCode: 'IMO Code',
  callSign: 'Call Sign',
  pAndI: 'P&I Club',
  class: 'Class',
  ss: 'SS',
  ssDate: ' Next special survey date',
  dd: 'DD',
  ddDate: 'Next docking survey date',
  mainEngine: 'Main Engine',
  shipyard: 'Ship Yard',
  speedFuel: 'Speed & Fuel',
  fuelType: 'Fuel Type',
  foDoConsump: 'Con.(MT/Day)',
  lsFoLSDoConsump: 'LS Con.(MT/Day)',
  doAtSea: 'Do Consumption',
  fuelConsumpUnit: 'MT/Day',
  atPortIdle: 'At Port(Idle)',
  atPortWork: 'At Port(Work)',
  fo: 'FO',
  do: 'DO',
  lsfo: 'LSFO',
  lsdo: 'LSDO',
  ecoSpeed: 'Eco Speed',
  seaBallast: 'Sea(Ballast)',
  seaLaden: 'Sea(Laden)',
  fullSpeed: 'Full Speed',
  seaDoConsumption: 'At Sea(DO Con.)',
  grainCapacity: 'Grain Capacity',
  baleCapacity: 'Bale Capacity',
  holdNum: 'Hold No.',
  hatchNum: 'Hatch No.',
  deckNum: 'Deck No.'

}
